const GET_GEO_CURRENCY_URL = '/geo-currency';
const GALLERIES_URL = {
	local: 'http://vigbogallery.localhost',
	dev: 'https://gallery-1.vigbo.tech',
	prod: 'https://gallery.photo'
};
const API_URL = '/api/v1/retouch-packages/currency';

const formatPrice = price => {
	const number = parseFloat(price).toFixed(2);
	const [integerPart, decimalPart] = number.split('.');
	const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	const formattedDecimal = decimalPart === '00' ? '' : `,${decimalPart}`;

	return formattedInteger + formattedDecimal;
};

const formatPackageName = handle => {
	const names = {
		MINI: 'Mini',
		SMALL: 'Small',
		MEDIUM: 'Medium',
		LARGE: 'Large'
	};
	return names[handle] || handle;
};

const getCurrencySymbol = curr => {
	return {
		RUR: 'руб.',
		USD: '$',
		EUR: '€'
	}[curr] || curr;
};

const detectCurrency = async () => {// eslint-disable-line
	try {
		const response = await fetch(GET_GEO_CURRENCY_URL);
		const {currency, symbol} = await response.json();
		const currencyActual = currency === 'RUB' ? 'RUR' : currency;
		return {currencyActual, symbol};
	} catch (error) {
		console.error('Error detecting currency:', error);
		return {currency: 'RUR', symbol: 'руб.'};
	}
};

const removeLoading = tariffsContainer => {
	if (tariffsContainer) {
		tariffsContainer.classList.remove('is--loading');
	}
};

const renderTariffs = (tariffs, currency, tariffsContainer) => {
	tariffsContainer.innerHTML = tariffs.map(tariff => {
		const pricePerPhoto = (parseFloat(tariff.price.price) / tariff.volume);
		const isPopular = tariff.handle === 'MEDIUM';

		return `<div class="retouch__prices--list-item">
${isPopular ? '<div class="retouch__prices--label">Самый выгодный</div>' : ''}
<div class="retouch__prices--list-item-name">${formatPackageName(tariff.handle)}</div>
<div class="retouch__prices--list-item-info">
<div class="retouch__prices--list-item-info-count">${tariff.volume}</div>
<div class="retouch__prices--list-item-info-photo">фото</div>
</div>
<div class="retouch__prices--list-item-price-info">
<div class="retouch__prices--list-item-price">${formatPrice(tariff.price.price)} ${getCurrencySymbol(currency)}</div>
<div class="retouch__prices--list-item-price-photo">${pricePerPhoto.toFixed(2).replace('.', ',')} ${getCurrencySymbol(currency)} / фото</div>
</div>
</div>`;
	}).join('');
};

const loadPrices = async (api_url, currency) => {// eslint-disable-line
	try {
		const response = await fetch(`${api_url}/${currency}`);
		const {success, data} = await response.json();

		if (!success) {
			throw new Error('Ошибка загрузки данных');
		}

		return data;
	} catch (error) {
		console.error('Error:', error);
	}
};

const render = () => {// eslint-disable-line
	(async () => {// eslint-disable-line
		const tariffsContainer = document.querySelector('.js--retouch__tariffs');
		const {currencyActual, symbol} = await detectCurrency();
		const GALLERY_URL = window.location.host === 'dev.vigbo.com' ? GALLERIES_URL.dev : GALLERIES_URL.prod;
		const tariffs = await loadPrices(`${GALLERY_URL}${API_URL}`, currencyActual, tariffsContainer);
		if (tariffs) {
			renderTariffs(tariffs, symbol, tariffsContainer);
		}
		removeLoading(tariffsContainer);
	})();
};

export default render;
